export const queryKeys = {
  BOSS_PAYMENT_STATISTIC: 'BOSS_PAYMENT_STATISTIC'
};
